import React, {Component, useEffect, useState} from 'react';
import axios from "axios";
import {Routes, Route, useParams, Navigate} from 'react-router-dom';
import "yet-another-react-lightbox/styles.css";
import Header from "./Components/Header";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import QuoteHeaders from "./Data/quotes.json"
import Layout from "./Components/Layout";


const CompareQuotes = () => {

    const [supplierData, setSupplierData] = useState(0);
    const [redirect, setRedirect] = React.useState(false);
    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(true); // Add loading state

    let { keyword } = useParams();
    useEffect(() => {

        let dataObj = {
            search: keyword,
            order: 'desc'
        }
        
        setLoading(true); // Set loading to true when API call starts
        
        axios.put(`get-suppliers-compare`, dataObj)
            .then(response => {
                const records = response.data;
                setSupplierData(records);
                setLoading(false); // Set loading to false when data is received
            }).catch(error => {
            console.error('There was an error!', error);
            setLoading(false); // Set loading to false even on error
        });
    }, []);

    const getFormattedDate = (dateString) => {
        if (dateString !== undefined) {
            // Split the date string and create date with local timezone
            const [year, month, day] = dateString.split('-');
            const myDate = new Date(year, month - 1, day); // month is 0-indexed
            
            return myDate.toLocaleDateString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            });
        }
    }

    const formatDateTime = (dateString) => {
        if(dateString !== undefined)
        {
            const myDate = new Date(dateString);

            return  myDate.toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            });

        }
    };

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };
    
    const getQuoteIndex = (index) => {
        let color = '#f3f4f6';
        let number = (index % 2 === 0) ? 1 : 0;
        switch(number) {
            case 0:
                color = '#f3f4f6'
                break;
            case 1:
                color = '#ffffff'
                break;
            default:
                color = '#f3f4f6' 
        }
        return color;
    };

    const getQuoteContent = keyData => {
        let content = [];
        for (let i = 0; i < supplierData.length; i++) {
            let item = supplierData[i];
            if(keyData === 'GoodThruDate') {
                content.push(<td>{getFormattedDate(item[keyData])}</td>);
            } else if(keyData === 'dateTimeCreated') {
                content.push(<td>{formatDateTime(item[keyData])}</td>);
            } else {
                content.push(<td>{item[keyData]}</td>);
            }

        }
        return content;
    };

    if(redirect)
    {
        return (<Navigate to="/suppliers-data"/>)
    }
    else {
        return (
            <Layout>
                <section className="section pb-0" style={{marginBottom: '130px'}}>
                    
                        <div className="row" style={{margin: '0px 10px 10px'}}>
                            <div className="col-lg-12 mb-12" style={{marginTop:'20px'}}>
                                <div style={{marginBottom: '20px'}}>
                                    <a className="" href="/suppliers-data" style={{backgroundColor: '#007bff', color: 'white', padding: '8px 16px', borderRadius: '4px', textDecoration: 'none', display: 'inline-block'}}>
                                        <i className="ti-angle-left"></i> BACK
                                    </a>
                                </div>

                                
                                <div className="row">
                                    <div className="col-lg-12 mb-12" style={{overflow:"scroll"}}>
                                        {loading ? (
                                            <div style={{textAlign: 'center', padding: '50px'}}>
                                                <p>Loading...</p>
                                            </div>
                                        ) : (
                                            <table className="table table-bordered">
                                                <tbody>
                                                {supplierData && QuoteHeaders.map((quote, quoteIndex )=> (
                                                    
                                                    <tr style={{background: getQuoteIndex(quoteIndex)}}>
                                                        <td className={'headerString'}>{quote.header}</td>
                                                        {getQuoteContent(quote.key)}
                                                        
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                                    

                            </div>

                            <div className="col-12">
                                <div className="border-bottom border-default"></div>
                            </div>
                        </div>
                    
                    <ToastContainer />
                </section>
            </Layout>
        );
    }

}

export default CompareQuotes;